import React from 'react';
import './button.css';
import Image from "../theme/Image";

export default function ({image, imageStyle, containerStyle, boxStyle, boxClassName, textStyle, width, height, padding="0.36rem", onClick, title, children}) {
    let imageEl;

    if(image && image !== false){
        let imageStyles = {
            display: "block",
            paddingTop: "1.43rem",
            marginLeft: "auto",
            marginRight: "auto",
            height: "4.57rem",
            maxWidth: '90%',
            ...imageStyle
        };
        imageEl = (
            <Image image={image} alt={'image'} style={imageStyles}/>
        );
    }

    let boxStyles = {
        width: "100%",
        height: "100%",
        position: "relative",
        overflowWrap: "anywhere",
        maxHeight: "100%",
        borderRadius: '0.71rem',
        ...(boxStyle ?? {})
    };

    let textStyles = {
        position: "absolute",
        bottom: "1.43rem",
        width: "100%",
        textAlign: "center",
        fontSize: '1.29rem',
        ...(textStyle ?? {})
    };

    return (
        <div style={{
            width: width || "100%",
            height: height || "100%",
            boxSizing: "border-box",
            padding,
            float: "left",
            ...containerStyle
        }} onClick={onClick}>
            <div className={boxClassName || 'darkGrayButton'} style={boxStyles}>
                {imageEl}
                {children}
                <div className={'boldUppercaseText'} style={textStyles}>{title}</div>
            </div>
        </div>
    );
}